import {
  IEmployeeWorkgroupActions,
  EmployeeWorkgroupContext
} from './actions.types';
import { IEmployeeWorkgroupData } from '@/models';

export const actions: IEmployeeWorkgroupActions = {
  fetchEmployeeWorkgroups(context: EmployeeWorkgroupContext): Promise<void> {
    return this.$services.employeeWorkgroup
      .fetchEmployeeWorkgroups()
      .then((employeeWorkgroups: IEmployeeWorkgroupData[]) => {
        context.commit('SET_WORKGROUPS', employeeWorkgroups);
      });
  },

  fetchEmployeeWorkgroup(
    context: EmployeeWorkgroupContext,
    payload: number
  ): Promise<void> {
    return this.$services.employeeWorkgroup
      .fetchEmployeeWorkgroup(payload)
      .then((employeeWorkgroup: IEmployeeWorkgroupData) => {
        const index = context.state.employeeWorkgroups.findIndex(
          (v: IEmployeeWorkgroupData) => v.id === employeeWorkgroup.id
        );
        if (index === -1) {
          context.commit('ADD_WORKGROUP', employeeWorkgroup);
        } else {
          context.commit('UPDATE_WORKGROUP', employeeWorkgroup);
        }
      });
  },

  createEmployeeWorkgroup(
    context: EmployeeWorkgroupContext,
    payload: IEmployeeWorkgroupData
  ): Promise<void> {
    return this.$services.employeeWorkgroup
      .createEmployeeWorkgroup(payload)
      .then((employeeWorkgroup: IEmployeeWorkgroupData) =>
        context.commit('ADD_WORKGROUP', employeeWorkgroup)
      );
  },

  updateEmployeeWorkgroup(
    context: EmployeeWorkgroupContext,
    payload: IEmployeeWorkgroupData
  ): Promise<void> {
    return this.$services.employeeWorkgroup
      .updateEmployeeWorkgroup(payload)
      .then((employeeWorkgroup: IEmployeeWorkgroupData) => {
        const index = context.state.employeeWorkgroups.findIndex(
          (v: IEmployeeWorkgroupData) => v.id === employeeWorkgroup.id
        );
        if (index === -1) {
          context.commit('ADD_WORKGROUP', employeeWorkgroup);
        } else {
          context.commit('UPDATE_WORKGROUP', employeeWorkgroup);
        }
      });
  },

  deleteEmployeeWorkgroup(
    context: EmployeeWorkgroupContext,
    payload: number
  ): Promise<void> {
    return this.$services.employeeWorkgroup
      .deleteEmployeeWorkgroup(payload)
      .then(() => {
        context.commit('REMOVE_WORKGROUP', payload);
      });
  }
};
